<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__agreement}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          prop="code"
          label="合同编号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="totalAmount"
          label="总金额"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ moneyFormat(scope.row.totalAmount) }}{{ scope.row.currency }}
          </template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="signTime"
          label="签订日期"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="deadline"
          label="交付日期"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="创建人"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="showReport(scope.row)"
              >费用统计</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
    </div>
    <AgreementAnsyl ref="agreementAnsyl"></AgreementAnsyl>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AgreementAnsyl from './agreement-ansyl'
export default {
  mixins: [mixinViewModule],
  components: {AgreementAnsyl},
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/agreement/page",
        getDataListIsPage: true,
      },
      dataForm: {
        id: "",
      },
    };
  },

  methods: {
    showReport(row){
      this.$refs.agreementAnsyl.id=row.id
      this.$refs.agreementAnsyl.init()
    }
  },
};
</script>
